module.exports = __webpack_public_path__ + "static/img/head-cool.4d73b13c.png";